module.exports = __webpack_public_path__ + "static/media/mongo.75923b7f.PNG";